import React from 'react';
import { Box, Typography } from '@mui/material';
import DynamicPackageCard from './DynamicPackageCard';

const DynamicCustomizedHolidays = ({ mainContent = [] }) => {
  if (!mainContent || mainContent.length === 0) return null;

  return (
    <Box sx={{ backgroundColor: '#f4f4f7', py: { xs: 4, md: 6 } }}>
      {mainContent.map((section, sectionIndex) => {
        const packages = section?.packages || [];
        if (packages.length === 0) return null;

        return (
          <Box
            key={`${section.title}-${sectionIndex}`}
            id={sectionIndex === 0 ? 'packagesSection' : `packagesSection-${sectionIndex}`}
            sx={{
              pb: sectionIndex < mainContent.length - 1 ? 6 : 0,
              scrollMarginTop: '100px'
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 4,
                px: { xs: 2, sm: 3, md: 4 }
              }}>
              <Box sx={{ flex: 1, height: '2px', backgroundColor: '#000' }} />
              <Typography
                sx={{
                  fontSize: { xs: '14px', sm: '16px', md: '18px' },
                  fontFamily: 'gothamBold',
                  textAlign: 'center',
                  color: '#27306B',
                  textTransform: 'uppercase',
                  whiteSpace: 'nowrap',
                  px: 3
                }}>
                {section.title}
              </Typography>
              <Box sx={{ flex: 1, height: '2px', backgroundColor: '#000' }} />
            </Box>

            <Box
              sx={{
                maxWidth: '1400px',
                margin: '0 auto',
                px: { xs: 2, sm: 3, md: 4 },
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(2, 1fr)',
                  md: 'repeat(3, 1fr)'
                },
                gap: 3,
                justifyItems: 'center',
                alignItems: 'start'
              }}>
              {packages.map((pkg, pkgIndex) => (
                <DynamicPackageCard
                  key={`${pkg.new_item_code || pkg.id}-${pkgIndex}`}
                  tourPackage={pkg}
                />
              ))}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default DynamicCustomizedHolidays;
